// import { useState, useEffect } from 'react';
// import { Nav, Table, Dropdown, Button, Card } from 'react-bootstrap';
// import { GraduationCap, ChevronDown, Microscope, Trophy, ScrollText } from 'lucide-react';
// import Catalog from '../CoursePages/Catalog';
// import axios from 'axios';
// // import Image from 'next/image';

// const coursesTabs = [
//   "My Courses",
//   "My Grades",
//   "My Memberships",
//   "My Groups",
//   "My Achievements",
//   "My Certificates",
//   "Notifications"
// ];

// const sortOptions = [
//   { label: "Enrollment Date (Most Recent)", value: "date-desc" },
//   { label: "Enrollment Date (Oldest)", value: "date-asc" },
//   { label: "Course Title (A-Z)", value: "title-asc" },
//   { label: "Course Title (Z-A)", value: "title-desc" }
// ];

// export default function CoursesSection() {
//   const [activeTab, setActiveTab] = useState("My Courses");
//   const [selectedSort, setSelectedSort] = useState(sortOptions[0]);
//   const [courses, setCourses] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchCourses = async () => {
//       setLoading(true);
//       const token = localStorage.getItem("jwttoken");
//       try {
//         const response = await axios.get("https://kaasbackend.vetrinahealthcare.com/lms/user/courses/",
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           });
//         setCourses(response.data);
//       } catch (err) {
//         setError(err.response?.data?.message || 'Failed to fetch courses');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchCourses();
//   }, []);

//   const renderContent = () => {
//     if (loading) {
//       return <div className="text-center text-muted py-5">Loading...</div>;
//     }

//     if (error) {
//       return <div className="text-center text-danger py-5">{error}</div>;
//     }

//     if (activeTab === "My Courses") {
//       return (
//         <div className="courses-container">
//           {courses.length > 0 ? (
//             courses.map((course) => (
//               <Catalog
//                 key={course.id}
//                 coursetitle={course.title}
//                 instructor={course.instructor}
//                 price={course.price}
//                 courseId={course.id}
//                 isWishlisted={course.isWishlisted}
//               />
//             ))
//           ) : (
//             <div className="d-flex flex-column align-items-center justify-content-center p-5">
//               <div className="text-muted mb-3">
//                 <GraduationCap size={48} />
//               </div>
//               <p className="text-muted mb-0">You do not have any courses yet.</p>
//             </div>
//           )}
//         </div>
//       );
//     }

//     if (activeTab === "My Grades") {
//       return (
//         <div>
//           <div className="d-flex justify-content-end mb-3 gap-2">
//             <Dropdown>
//               <Dropdown.Toggle
//                 variant="light"
//                 className="d-flex align-items-center gap-2 border"
//               >
//                 {selectedSort.label}
//                 <ChevronDown size={16} />
//               </Dropdown.Toggle>

//               <Dropdown.Menu>
//                 {sortOptions.map((option) => (
//                   <Dropdown.Item
//                     key={option.value}
//                     active={selectedSort.value === option.value}
//                     onClick={() => setSelectedSort(option)}
//                   >
//                     {option.label}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>
//             <Button variant="primary">Update</Button>
//           </div>

//           <Table hover className="align-middle">
//             <thead>
//               <tr>
//                 <th className="text-muted fw-normal">COURSE</th>
//                 <th className="text-muted fw-normal">ENROLLMENT DATE</th>
//                 <th className="text-muted fw-normal">PROGRESS</th>
//                 <th className="text-muted fw-normal">GRADE</th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td colSpan={4} className="text-center text-muted py-5">
//                   No grades available
//                 </td>
//               </tr>
//             </tbody>
//           </Table>
//         </div>
//       );
//     }

//     if (activeTab === "My Memberships") {
//       return (
//         <div className="d-flex flex-column align-items-center justify-content-center p-5" style={{ minHeight: '400px' }}>
//           <div className="text-muted mb-3">
//             <Microscope size={48} />
//           </div>
//           <p className="text-muted mb-0">You do not have any memberships yet.</p>
//         </div>
//       );
//     }

//     if (activeTab === "My Groups") {
//       return (
//         <div>
//           <Card
//             className="border-0 bg-light mb-3"
//             style={{ maxWidth: '600px' }}
//           >
//             <Card.Body className="d-flex align-items-center gap-3">
//               <div style={{ width: '80px', height: '80px' }}>
//                 <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%' }}>
//                   <path
//                     d="M10,10 L90,10 L50,50 L10,10 M10,90 L90,90 L50,50 L10,90 M90,10 L90,90 L50,50 L90,10"
//                     fill="#8B0000"
//                   />
//                 </svg>
//               </div>
//               <div>
//                 <h5 className="mb-0">New Group</h5>
//               </div>
//             </Card.Body>
//           </Card>
//         </div>
//       );
//     }

//     if (activeTab === "My Achievements") {
//       return (
//         <div className="d-flex flex-column align-items-center justify-content-center p-5" style={{ minHeight: '400px' }}>
//           <div className="text-muted mb-3">
//             <Trophy size={48} />
//           </div>
//           <p className="text-muted mb-0">You do not have any achievements yet.</p>
//           <p className="text-muted small">Enroll in a course to get started!</p>
//         </div>
//       );
//     }

//     if (activeTab === "My Certificates") {
//       return (
//         <div className="d-flex flex-column align-items-center justify-content-center p-5" style={{ minHeight: '400px' }}>
//           <div className="text-muted mb-3">
//             <ScrollText size={48} />
//           </div>
//           <p className="text-muted mb-0">You do not have any certificates yet.</p>
//         </div>
//       );
//     }

//     return (
//       <div className="text-center text-muted p-5">
//         {activeTab} content goes here
//       </div>
//     );
//   };

//   return (
//     <div className="card shadow-sm">
//       <div className="card-body p-0">
//         <Nav className="border-bottom gap-4 px-4">
//           {coursesTabs.map((tab) => (
//             <Nav.Item key={tab}>
//               <Nav.Link
//                 onClick={() => setActiveTab(tab)}
//                 className={`py-3 px-1 border-bottom border-3 ${
//                   activeTab === tab ? 'border-primary text-primary' : 'border-transparent text-muted'
//                 }`}
//               >
//                 {tab}
//               </Nav.Link>
//             </Nav.Item>
//           ))}
//           <Nav.Item className="ms-auto">
//             <Nav.Link className="py-3 px-1 text-muted">
//               •••
//             </Nav.Link>
//           </Nav.Item>
//         </Nav>

//         <div className="p-4">
//           {renderContent()}
//         </div>
//       </div>
//       <div className="text-muted small p-3">
//         © 2024 - TDTL MS
//       </div>
//     </div>
//   );
// }
import { useState, useEffect } from 'react';
import { Nav, Card, ProgressBar, Spinner, Button, Row, Col } from 'react-bootstrap';
import { GraduationCap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

// Add custom purple styles
const purpleTheme = {
  primary: '#6f42c1', // Bootstrap's purple
  light: '#e2d9f3',
  dark: '#59359a',
  gradient: 'linear-gradient(135deg, #6f42c1 0%, #8a2be2 100%)'
};

const coursesTabs = [
  'My Courses',
  'My Grades',
  'My Memberships',
  'My Achievements',
];

const MAX_DESCRIPTION_LENGTH = 100;

export default function CourseSection() {
  const [activeTab, setActiveTab] = useState('My Courses');
  const [displayedCards, setDisplayedCards] = useState(3);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [role, setRole] = useState('');
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const userRole = localStorage.getItem('role');
    setRole(userRole);
  }, []);

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      const token = localStorage.getItem('jwttoken');

      try {
        const response = await axios.get(
          'https://kaasbackend.vetrinahealthcare.com/lms/user/courses/',
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (Array.isArray(response.data)) {
          setCourses(response.data);
        } else if (response.data && Array.isArray(response.data.courses)) {
          setCourses(response.data.courses);
        } else {
          setCourses([]);
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch courses');
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

  const redirect = (id) => {
    navigate(`/Course/${id}`);
  };

  const handleViewAll = () => setDisplayedCards(courses.length);
  const handleViewLess = () => setDisplayedCards(3);

  const toggleDescription = (courseId) => {
    setExpandedDescriptions(prev => ({
      ...prev,
      [courseId]: !prev[courseId]
    }));
  };

  const renderDescription = (description, courseId) => {
    if (!description) return <p className="text-muted mb-3">No description available</p>;
    
    const isExpanded = expandedDescriptions[courseId];
    
    if (description.length <= MAX_DESCRIPTION_LENGTH || isExpanded) {
      return (
        <div className="mb-3">
          <p className="mb-1">
            <strong>Description:</strong> {description}
          </p>
          {description.length > MAX_DESCRIPTION_LENGTH && (
            <Button 
              variant="link" 
              size="sm" 
              onClick={() => toggleDescription(courseId)}
              style={{ color: purpleTheme.primary }}
              className="p-0"
            >
              Show less
            </Button>
          )}
        </div>
      );
    }
    
    return (
      <div className="mb-3">
        <p className="mb-1">
          <strong>Description:</strong> {description.substring(0, MAX_DESCRIPTION_LENGTH)}...
        </p>
        <Button 
          variant="link" 
          size="sm" 
          onClick={() => toggleDescription(courseId)}
          style={{ color: purpleTheme.primary }}
          className="p-0"
        >
          Show more
        </Button>
      </div>
    );
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className='text-center py-5'>
          <Spinner animation='border' style={{ color: purpleTheme.primary }} />
          <p className='mt-2'>Loading your courses...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className='text-center py-5'>
          <div className='alert alert-danger'>
            {error}
          </div>
          <Button 
            style={{ backgroundColor: purpleTheme.primary, borderColor: purpleTheme.primary }}
            onClick={() => window.location.reload()}
            className='mt-3'
          >
            Try Again
          </Button>
        </div>
      );
    }

    if (activeTab === 'My Courses') {
      return (
        <>
          {courses.length > 3 && (
            <div className='d-flex justify-content-end mb-4'>
              {displayedCards >= courses.length ? (
                <Button
                  variant="outline-purple"
                  onClick={handleViewLess}
                  className='me-2'
                  style={{ 
                    color: purpleTheme.primary,
                    borderColor: purpleTheme.primary
                  }}
                >
                  <FontAwesomeIcon icon={faChevronUp} className='me-2' />
                  Show Less
                </Button>
              ) : (
                <Button
                  variant="outline-purple"
                  onClick={handleViewAll}
                  style={{ 
                    color: purpleTheme.primary,
                    borderColor: purpleTheme.primary
                  }}
                >
                  <FontAwesomeIcon icon={faChevronDown} className='me-2' />
                  Show All ({courses.length})
                </Button>
              )}
            </div>
          )}

          <Row>
            {courses.slice(0, displayedCards).map((course) => (
              <Col key={course.course_id} lg={4} md={6} className='mb-4'>
                <Card className='h-100 shadow-sm' style={{ borderTop: `3px solid ${purpleTheme.primary}` }}>
                  <Card.Body className='d-flex flex-column'>
                    <Card.Title className='h5' style={{ color: purpleTheme.primary }}>
                      {course.title}
                    </Card.Title>
                    <Card.Subtitle className='mb-3 text-muted small'>
                      <i className="far fa-calendar-alt me-2"></i>
                      Started: {course.start_date || 'Not specified'}
                    </Card.Subtitle>
                    
                    {renderDescription(course.description, course.course_id)}

                    {role === 'Instructor' ? (
                      <div className='d-flex justify-content-between bg-light p-3 mb-3 rounded'>
                        <div>
                          <small className='text-muted d-block'>Students</small>
                          <span className='fw-bold'>{course.students || 0}</span>
                        </div>
                        <div className='text-end'>
                          <small className='text-muted d-block'>Revenue</small>
                          <span className='fw-bold'>
                            ₹{course.revenue?.toFixed(2) || '0.00'}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className='mb-4'>
                        <div className='d-flex justify-content-between mb-2'>
                          <small className='text-muted'>Your progress</small>
                          <small className='fw-bold'>
                            {course.progress ? `${(course.progress * 100).toFixed(0)}%` : '0%'}
                          </small>
                        </div>
                        <ProgressBar
                          now={course.progress ? course.progress * 100 : 0}
                          style={{ backgroundColor: purpleTheme.light }}
                        >
                          <ProgressBar 
                            variant="" 
                            style={{ backgroundColor: purpleTheme.primary }} 
                            animated={course.progress && course.progress < 1}
                          />
                        </ProgressBar>
                      </div>
                    )}

                    <Button
                      style={{ 
                        backgroundColor: purpleTheme.primary,
                        borderColor: purpleTheme.primary
                      }}
                      onClick={() => redirect(course.course_id)}
                      className='mt-auto'
                    >
                      <i className="far fa-eye me-2"></i>
                      View Course
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {courses.length === 0 && (
            <div className='text-center py-5'>
              <GraduationCap size={48} style={{ color: purpleTheme.primary }} className='mb-3' />
              <h5 className='mb-2'>No courses found</h5>
              <p className='text-muted mb-4'>You don't have any courses yet.</p>
              <Button style={{ backgroundColor: purpleTheme.primary, borderColor: purpleTheme.primary }}>
                Browse Available Courses
              </Button>
            </div>
          )}
        </>
      );
    }

    return (
      <div className='text-center py-5'>
        <div className='alert alert-info'>
          {activeTab} content is coming soon!
        </div>
      </div>
    );
  };

  return (
    <div className='card shadow-sm border-0'>
      <style>{`
        .nav-tabs .nav-link.active {
          color: ${purpleTheme.primary};
          border-color: ${purpleTheme.primary} ${purpleTheme.primary} #fff;
          font-weight: 600;
        }
        .nav-tabs .nav-link:hover {
          border-color: ${purpleTheme.light} ${purpleTheme.light} ${purpleTheme.primary};
        }
      `}</style>
      
      <div className='card-body p-0'>
        <Nav variant='tabs' className='px-3 border-bottom' defaultActiveKey="My Courses">
          {coursesTabs.map((tab) => (
            <Nav.Item key={tab}>
              <Nav.Link
                eventKey={tab}
                active={activeTab === tab}
                onClick={() => setActiveTab(tab)}
                className='py-3 px-4'
              >
                {tab}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        
        <div className='p-4'>
          {renderContent()}
        </div>
      </div>
      
      <div className='card-footer text-muted small text-center py-3 bg-light'>
        © {new Date().getFullYear()} VetrinaHealthcare Pvt LTD
      </div>
    </div>
  );
}